import { render, staticRenderFns } from "./Greetings.vue?vue&type=template&id=69633954"
import script from "./Greetings.vue?vue&type=script&lang=ts"
export * from "./Greetings.vue?vue&type=script&lang=ts"
import style0 from "./Greetings.vue?vue&type=style&index=0&id=69633954&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports